function Formation() {



    return(
        <article>
              
                <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Création et développement de contenu pédagogiques</p>
                <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Élaboration d’exercices</p>
                <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Suivi des apprenants dans les différents cursus</p>
                <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Préparation à un examen final</p>
                <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Création de mes plannings</p>
              
            </article>
    )
}

export default Formation